import { makeStyles } from '@material-ui/core';

const useVersionTextStyle = makeStyles({
  h1: {
    color: 'white',
    marginLeft: 134,
    marginTop: -18,
    fontSize: 12,
  },
});

export const SidebarVersion = () => {
  const classes = useVersionTextStyle();
  return (
    <div>
      <h1 className={classes.h1}>1.56.2</h1>
    </div>
  );
};
